import { Box, Skeleton, Stack } from '@mantine/core';
import { Outlet, useParams } from 'react-router';

import { ErrorBoundary } from '../components/ErrorBoundary';
import { useGame } from '../data/games';

export const GamePage = () => {
    const { id: gameId } = useParams();
    const game = useGame(gameId!);

    if (!game) {
        return (
            <Box px={{ base: 'sm', sm: 'md', lg: 'lg' }} py="lg">
                <Stack gap="md">
                    <Skeleton height={200} radius="sm" animate />
                    <Box
                        display="grid"
                        style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '1rem' }}
                    >
                        <Skeleton height={160} radius="sm" animate />
                        <Skeleton height={160} radius="sm" animate />
                    </Box>
                    <Skeleton height={240} radius="sm" animate />
                </Stack>
            </Box>
        );
    }

    return (
        <ErrorBoundary>
            <Outlet key={gameId} context={{ game, gameId }} />
        </ErrorBoundary>
    );
};
